import { render, staticRenderFns } from "./ResolutionsLandingPage.vue?vue&type=template&id=6f2f7aee&scoped=true"
import script from "./ResolutionsLandingPage.vue?vue&type=script&lang=js"
export * from "./ResolutionsLandingPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2f7aee",
  null
  
)

export default component.exports